<app-notifications-table></app-notifications-table>


// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/notifications/notifications.component.html